module.exports = __webpack_public_path__ + "static/media/success_icon.354c3ff9.svg";